<template>
  <v-container>
    <v-layout
      row
      pt-10
    >
      <v-flex
        xs12
        sm6
        offset-sm3
      >
        <h2
          class="primary--text"
        >
          Register a Dancer
        </h2>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex
        xs12
      >
        <form @submit.prevent="onCreateDancer">
          <v-layout
            row
          >
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <v-text-field
                id="first-name"
                v-model="firstName"
                name="first-name"
                label="First Name"
                required
              />
              <v-text-field
                id="last-name"
                v-model="lastName"
                name="last-name"
                label="Last Name"
                required
              />
              <v-text-field
                id="email"
                v-model="email"
                name="email"
                label="Email"
                type="email"
                required
              />
            </v-flex>
          </v-layout>
          <v-layout
            row
            pt-5
          >
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <v-btn
                class="primary"
                :disabled="!formIsValid"
                type="submit"
              >
                Create Dancer & Add Another
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        firstName: '',
        lastName: '',
        email: ''
      }
    },
    computed: {
      formIsValid () {
        return this.firstName !== '' && this.lastName !== '' && this.email !== ''
      }
    },
    methods: {
      onCreateDancer () {
        if (!this.formIsValid) {
          return
        }
        const dancerData = {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email
        }
        this.$store.dispatch('createDancer', dancerData)
        this.firstName = ''
        this.lastName = ''
        this.email = ''
      }
    }
  }
</script>
